import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';

import './CardTotalStickers.css'

export default ({stickerCount}) => (
	<Card className="card-total-stickers">
		<CardTitle title="Aktive Smart Stickers"/>
		<CardText>
			{ stickerCount }
		</CardText>
	</Card>
);


// WEBPACK FOOTER //
// ./src/components/summary/cards/CardTotalStickers.jsx